import iconImage from '../../../images/tandc_icon.svg'

import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'

import { HEADER_TEXT_COLOR, MINOR_HEADER_COLOR, MOBILE_BREAKPOINT } from 'broker/util/constants'
import { selectBrokerCompany, selectAccountLoading } from 'broker/selectors/account'
import SLBrokerName from 'broker/views/components/SkeletonLoader/SLBrokerName'

const TitleWrapper = styled.div`
  min-height: 68px;
  height: fit-content;
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0 1px 0 0 rgba(182,182,182,0.5);

  color: ${HEADER_TEXT_COLOR};
  font-family: "Circular", sans-serif;
  padding: 10px 40px;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
`

const ContentWrapper = styled.div`
  position: relative;
  height: fit-content;
  width: 100%;
  font-size: 22px;
  color: ${HEADER_TEXT_COLOR};
  font-weight: 500;
  line-height: 28px;
  text-align: center;
  display: flex;
  align-items: center;
  @media${MOBILE_BREAKPOINT} {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
  }
`

const CompanyWrapper = styled.div`
  display: inline-block;
  margin: 0 auto;

  @media${MOBILE_BREAKPOINT} {
    display: block;
  }
`

const TermsAndFeesLinksContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  position: absolute;
  right: 0;
`

const TermsLinkWrapper = styled.a`
  font-family: "Circular", sans-serif;
  display: flex;
  align-items: center;
  text-wrap: nowrap;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  margin-bottom: 10px;
  color: ${MINOR_HEADER_COLOR}
  cursor: pointer;
  letter-spacing: 0.12px;

  @media${MOBILE_BREAKPOINT} {
    flex-basis: 100%;
    top: unset;
    right: unset;
    position: relative;
    margin-top: 8px;
  }
`

const ReferralFeesLinkWrapper = styled.a`
  font-family: "Circular", sans-serif;
  display: flex;
  align-items: center;
  text-wrap: nowrap;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: ${MINOR_HEADER_COLOR}
  cursor: pointer;
  letter-spacing: 0.12px;

  @media${MOBILE_BREAKPOINT} {
    flex-basis: 100%;
    top: unset;
    right: unset;
    position: relative;
    margin-top: 8px;
  }
`

const TermsIconWrapper = styled.div`
  background-image: url(${iconImage});
  background-size: contain;
  width: 18px;
  height: 18px;
  display: inline-block;
  margin-right: 4px;
  background-repeat: no-repeat;
  `

const ReferralFeesIconWrapper = styled.div`
  margin-right: 4px;
`

const PageTitle = ({ company, loading }) => (
  <TitleWrapper>
    { loading || !company ?
      <ContentWrapper>
        <SLBrokerName/>
      </ContentWrapper> :
      <ContentWrapper>
        <CompanyWrapper>
          { company }
        </CompanyWrapper>
        <TermsAndFeesLinksContainer>
          <TermsLinkWrapper href="/terms" target="_blank"><TermsIconWrapper/> View Terms and Conditions</TermsLinkWrapper>
          <ReferralFeesLinkWrapper href="/referral-fees" target="_blank"><ReferralFeesIconWrapper className="fa fa-dollar"/> View ReadyConnect Concierge referral & applicable broker fees </ReferralFeesLinkWrapper>
        </TermsAndFeesLinksContainer>
      </ContentWrapper>
    }
  </TitleWrapper>
)

const mapStateToProps = state => ({
  company: selectBrokerCompany(state),
  loading: selectAccountLoading(state)
})

export default connect(mapStateToProps)(PageTitle)
